module.exports = __webpack_public_path__ + "static/media/728x90_0014_ro.33d0cedb.jpg";